export const CCOD_VISIBLE = {
  DEFAULT: false,
  SA: true
};
